import { ProposalReviewStatus } from "./__generated__/enums/proposal_review_status";

export type ProposalStatusToBoolean = { [key in ProposalReviewStatus]: boolean };

export const TECHNOLOGY_READINESS_LEVELS = {
  1: "Basic principles observed",
  2: "Concept development",
  3: "Experimental proof of concept",
  4: "Validated in lab conditions",
  5: "Validated in relevant environment",
  6: "Demonstrated in relevant environment",
  7: "Regulatory approval",
  8: "Product in production",
  9: "Product in market",
};

export interface CompanyProposalLibraryFilterOptions {
  rfpIdFilter?: string[];
  requestIdFilter?: string[];
  countryFilter?: string[];
  keywordFilter?: string[];
  institutionTypeFilter?: string[];
  institutionNameFilter?: string[];
  technologyReadinessLevelFilter?: string[];
  searchFilter?: string[];
  searchDirection?: "ASC" | "DESC";
  pageNumber?: number;
}
